import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Heading from '../components/heading/Heading';

const Signed = ( props ) => {
    const dispatch = useDispatch()
    
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const fileName = params.get("signedPdf");
        if (fileName) {
            console.log(`http://dubaj.kalkulator-grenke.hekko24.pl:5000/signed/${fileName}`);
            dispatch( {type: 'SIGNED_FILE_URL', value:  `http://dubaj.kalkulator-grenke.hekko24.pl:5000/signed/${fileName}` } ) 
        }
    }, []);

    return (
        <section className="form">
            <div className="container thanks-container">
                <div className="thanks">
                    <div className="text-box">
                        <Heading title={`Dokument został podpisany, kontynuuj wypełnianie formularza poniżej`} />
                    </div>
                </div>
            </div>
        </section>
    )
    
}

export default Signed;